import { createFileRoute } from '@tanstack/react-router'
import { IpqsPage } from '@/features/admin/ipqs/pages/ipqs-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/ipqs/')({
  component: IpqsPage,
  beforeLoad: requireRole(['admin']),
})
